import React, { useState } from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';

const ResponsiveGridLayout = WidthProvider(Responsive);

const GridTestPage = () => {
  const [layouts, setLayouts] = useState({
    lg: [
      { i: 'a', x: 0, y: 0, w: 1, h: 2, static: true },
      { i: 'b', x: 1, y: 0, w: 3, h: 2, minW: 2, maxW: 4 },
      { i: 'c', x: 4, y: 0, w: 1, h: 2 },
    ],
  });

  const onLayoutChange = (layout, newLayouts) => {
    setLayouts(newLayouts);
  };

  return (
    <div className="p-4 bg-background">
      <h1 className="text-2xl font-bold mb-4">Grid Test Page</h1>
      <ResponsiveGridLayout
        className="layout"
        layouts={layouts}
        onLayoutChange={onLayoutChange}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
        rowHeight={30}
      >
        <div key="a" style={{ border: '1px solid black' }}>a</div>
        <div key="b" style={{ border: '1px solid black' }}>b</div>
        <div key="c" style={{ border: '1px solid black' }}>c</div>
      </ResponsiveGridLayout>
    </div>
  );
};

export default GridTestPage;
